import { render } from "./TeamEdit.vue?vue&type=template&id=5e6fb648&scoped=true"
import script from "./TeamEdit.vue?vue&type=script&lang=js"
export * from "./TeamEdit.vue?vue&type=script&lang=js"

import "./TeamEdit.vue?vue&type=style&index=0&id=5e6fb648&lang=less&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6fb648"]])

export default __exports__